import { createContext } from 'react';

import { captureException } from '@sentry/browser';

import type { AppConfigUpserter } from '@cognite/apm-config';
import type { CogniteClient } from '@cognite/sdk';

import { getAppConfigClient } from '../../../utils/utils';

export interface UseUpsertAppConfigMutationContextInterface {
  captureException: typeof captureException;
  getAppConfigClient: (
    cogniteClient: CogniteClient,
    schemaVersionOverride?: number
  ) => AppConfigUpserter;
}

export const defaultValue: UseUpsertAppConfigMutationContextInterface = {
  captureException,
  getAppConfigClient,
};

export const UseUpsertAppConfigMutationContext =
  createContext<UseUpsertAppConfigMutationContextInterface>(defaultValue);
